<template>
  <img
    :src="apiImage ?
      `${filename}` :
      require(`@/assets/img/${filename}`)"
    :alt="alt"
    :title="thetitle"
    />
</template>

<script>
export default {
  name: 'logo',
  props: {
    filename: {
      type: String,
      default: 'zerocoma.png'
    },
    alt: {
      type: String,
      default: 'EdasNEO'
    },
    title: {
      type: String,
      default: null
    },
    apiImage: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      thetitle: this.title ? this.title : this.alt,
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>
